module.exports = "./images/08_nubile.jpg";